/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
import Text from '../../../assets/styles/Text';
import GroupInput from '../../../components/GroupInput';
import * as styles from '../styles';

export default function BasicInfoSection({
  formData,
  updateFormField,
  cities,
}) {
  return (
    <styles.SectionContent>
      <Text.H1>DESCRIÇÃO BÁSICA </Text.H1>

      {/* Nome Fantasia */}
      <GroupInput>
        <label>Nome Fantasia*</label>
        <input
          type="text"
          placeholder="Digite seu nome fantasia"
          value={formData.nameFantasy}
          onChange={(e) => updateFormField('nameFantasy', e.target.value)}
          maxLength={50}
        />
      </GroupInput>

      {/* Frase de Impacto */}
      <GroupInput>
        <label>
          Frase de impacto <span> - máximo de 80 caracteres</span>
        </label>
        <input
          type="text"
          placeholder="Digite uma frase de impacto"
          maxLength={80}
          value={formData.impactPhrase}
          onChange={(e) => {
            const value = e.target.value;
            updateFormField('impactPhrase', value);
          }}
        />
        <small>{formData.impactPhrase.length}/80 caracteres</small>
      </GroupInput>

      {/* Descrição */}
      <GroupInput>
        <label>Sobre você</label>
        <textarea
          placeholder="Digite sobre você"
          value={formData.description}
          onChange={(e) => updateFormField('description', e.target.value)}
          maxLength={500}
          rows={4}
        />
      </GroupInput>

      {/* Cidade */}
      <GroupInput select={Boolean(formData.selectedCity)}>
        <label>Sua cidade*</label>
        <select
          value={formData.selectedCity}
          onChange={(e) => updateFormField('selectedCity', e.target.value)}
        >
          <option value="" disabled>
            Escolha uma opção
          </option>
          {cities.map((city) => (
            <option value={city.id} key={city.id}>
              {city.name} - {city.stateAc}
            </option>
          ))}
        </select>
      </GroupInput>

      {/* Bairro */}
      <GroupInput>
        <label>Bairro</label>
        <input
          type="text"
          placeholder="Digite o bairro"
          value={formData.district}
          onChange={(e) => updateFormField('district', e.target.value)}
        />
      </GroupInput>
    </styles.SectionContent>
  );
}
